import { useState } from 'react';
import { extractApiErrorMessage } from '@/lib/error-utils';
import { login } from '@/lib/auth';
import { useAuth } from './action';

export function LoginForm() {
  const { toggleForm } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await login({ username, password });
      window.location.href = '/trang-chu';
    } catch (err: any) {
      const apiMessage = extractApiErrorMessage({
        status: err?.response?.status,
        data: err?.response?.data,
        fallbackMessage: 'Đăng nhập thất bại. Vui lòng kiểm tra lại tài khoản và mật khẩu.'
      });
      setError(apiMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {/* Localized Form Header */}
      <div className='mb-8 text-center'>
        <h2 className='text-3xl font-extrabold tracking-tight text-slate-900'>Đăng nhập</h2>
        <p className='mt-2 text-sm text-slate-500'>Nhập thông tin tài khoản để tiếp tục làm việc trên hệ thống.</p>
      </div>

      <form className='flex flex-col gap-5' onSubmit={handleSubmit}>
        {error && (
          <div className='animate-fade-in rounded-xl border border-red-100 bg-red-50/80 px-4 py-2.5 text-center text-xs font-semibold text-red-600'>
            {error}
          </div>
        )}

        <div>
          <label className='block pb-1.5 text-xs font-bold uppercase tracking-wider text-slate-500'>Tài khoản</label>
          <input
            type='text'
            className='h-11 w-full rounded-xl border border-slate-200 bg-slate-50/50 px-4 text-sm text-slate-900 outline-none transition-all duration-200 placeholder:text-slate-400 hover:border-slate-300 hover:bg-slate-50 focus:border-[#023e8a] focus:bg-white focus:ring-4 focus:ring-[#023e8a]/10'
            placeholder='Tên đăng nhập hoặc email'
            value={username}
            onChange={e => setUsername(e.target.value)}
            required
            autoComplete='username'
          />
        </div>

        <div>
          <div className='flex justify-between pb-1.5'>
            <label className='block text-xs font-bold uppercase tracking-wider text-slate-500'>Mật khẩu</label>
            <button
              type='button'
              onClick={() => toggleForm('forgot-password')}
              className='text-xs font-bold text-[#023e8a] transition-colors hover:text-[#012e66]'
              tabIndex={-1}
            >
              Quên mật khẩu?
            </button>
          </div>
          <div className='relative'>
            <input
              type='password'
              className='h-11 w-full rounded-xl border border-slate-200 bg-slate-50/50 px-4 text-sm text-slate-900 outline-none transition-all duration-200 placeholder:text-slate-400 hover:border-slate-300 hover:bg-slate-50 focus:border-[#023e8a] focus:bg-white focus:ring-4 focus:ring-[#023e8a]/10'
              placeholder='Nhập mật khẩu của bạn'
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              autoComplete='current-password'
            />
          </div>
        </div>

        <button
          type='submit'
          className='mt-2 h-11 w-full rounded-xl bg-[#023e8a] text-sm font-bold text-white shadow-sm transition-all duration-150 hover:bg-[#012e66] focus:outline-none focus:ring-4 focus:ring-[#023e8a]/20 active:scale-[0.985] disabled:cursor-not-allowed disabled:bg-[#023e8a]/50'
          disabled={loading}
        >
          {loading ? (
            <span className='flex items-center justify-center gap-2'>
              <svg className='h-4 w-4 animate-spin text-white' fill='none' viewBox='0 0 24 24'>
                <circle className='opacity-25' cx='12' cy='12' r='10' stroke='currentColor' strokeWidth='4' />
                <path
                  className='opacity-75'
                  fill='currentColor'
                  d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'
                />
              </svg>
              Đang đăng nhập...
            </span>
          ) : (
            'Đăng nhập'
          )}
        </button>
      </form>
    </div>
  );
}
